export default __webpack_public_path__ + "static/3-coinstack-b17aad46f99ccfaa781e5c4948d8ef70.png";